// 式神の加入の小窓：「○○が仲間になりたそうにこちらを見ている」→「仲間にする」で「○○が仲間になった！」。
// 手動の戦闘のリザルト・オート周回（1戦ごと・閉じていたあいだの精算）・掃討で、リザルト（まとめ）の前に出す。同じ種族は1回だけ
import { ENEMIES, SHIKIGAMI } from '@hyakki/core';
import { jingle } from '../audio';
import { shikiArtHtml } from '../assets';
import { esc } from './dom';
import { icon } from './icons';
import { openModal } from './overlay';
import { confetti } from './confetti';
import { state } from '../state';

/** この端末で小窓を出した種族（式神は一度仲間になったらもう勧誘しないので、種族で十分） */
const shown = new Set<string>();

/** 報酬の並びから、新しく仲間になった種族（まだ小窓を出していないもの） */
export function newRecruits(list: { shikigami?: { enemyId: string; recruited: boolean; dup?: boolean }[] }[]): string[] {
  const ids = list.flatMap((rw) => (rw.shikigami ?? []).filter((s) => s.recruited && !s.dup).map((s) => s.enemyId));
  return [...new Set(ids)].filter((id) => !shown.has(id));
}

/** 仲間になった式神の小窓を1体ずつ出し、紙吹雪。出したものは覚えて二度出さない */
export async function showRecruits(ids: string[]) {
  const list = [...new Set(ids)].filter((id) => !shown.has(id));
  if (!list.length) return;
  // 先に全部覚える（続けて呼ばれても同じ種族を二重に出さない）
  for (const id of list) shown.add(id);
  for (const id of list) {
    await new Promise<void>((resolve) => {
      const name = SHIKIGAMI[id]?.name ?? ENEMIES[id]?.name ?? '';
      const m = openModal(
        `<div class="recruit-ev" data-step="ask"><span class="rc-art">${shikiArtHtml(id, 200, 1)}</span>
          <p class="rc-ask"><b>${esc(name)}</b>が<br>仲間になりたそうに<br>こちらを見ている…</p>
          <p class="rc-done"><b>${esc(name)}</b>が仲間になった！<small>式神は持っているだけで4人全員が強くなり、式神召喚にセットすると戦いで助けてくれる。式神Lvを上げると進化する</small></p>
          <button class="btn primary big wide rc-yes" data-rc-yes>${icon('shiki')}仲間にする</button>
          <button class="btn big wide rc-close" data-close>閉じる</button></div>`,
        { title: '式神', className: 'recruit-modal', onClose: () => resolve() },
      );
      m.body.addEventListener('click', (e) => {
        if (!(e.target as HTMLElement).closest('[data-rc-yes]')) return;
        m.body.querySelector<HTMLElement>('.recruit-ev')!.dataset.step = 'done';
        void jingle('levelup', { keepBgm: true });
      });
    });
  }
  confetti({ reduced: state.settings.reduceShake });
}
